<template>
  <div id="hrms12x">
    <hrms-search-box-table  v-model="searchIndex"
                            :data="index.table"
                            :nowLang="dash.nowLang"
                            :columns="columns[dash.nowLang].index"
                            :unLoadBool="true"
                            :receivedStore="receivedHrms12xIndex"
                            searchBoxAlias="hrms12x"
                            :listFields="listFields"
                            :selectRowBool="false"
                            :selectBtnDisp="true"
                            :selectEvent="selectEvent"
                            ref="hrms12xIndex" />
    <div class="form-group-button" v-show="false">
      <button class="btn bg-blue" data-toggle="modal" ref="sendmail" data-target="#hrms12x-popup-sendmail"><i class="fa fa-list-alt"></i> {{ btn_sendmail }}</button>
    </div>
    <popup-send-mail    :labels="labels[dash.nowLang]"
                        :labelsButton="dash.button[dash.nowLang]"
                        :data="detail"
                        :currentUser="dash.currentUser.username[dash.nowLang]"
                        :nowLang="dash.nowLang"
                        :postSendmail="postSendmail"
                        :empmail="empmail"
                        :triggerIndexSelect="triggerIndexSelect"
                        :triggerSuccess="triggerSuccess"
                        :fileName="detail.attach"
                        :receiveClearDetail="receiveClearDetail"
                        :sendMailDisp="sendMailDisp"
                        :notSendDisp="notSendDisp"
                        :dataNotSend="dataNotSend"
                        :columns="columns[dash.nowLang].notSend" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms12x/mutation-types'
import popupSendMail from 'components/hrms12x/popupSendMail'
import moment from 'moment'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms12x',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      btn_approve: 'Send Mail',
      searchIndex: {
        syncond: {
          code: '',
          description: ''
        }
      }
    }
  },
  created () {
    this.receivedHrms12xColumnsLabels()
    this.receivedHrms12xListFields()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      columns: types.GET_HRMS12X_COLUMNS,
      labels: types.GET_HRMS12X_LABELS,
      index: types.GET_HRMS12X_INDEX,
      sendmail: types.GET_HRMS12X_SENDMAIL,
      listFields: types.GET_HRMS12X_LISTFIELDS,
      empmail: types.GET_HRMS12X_EMPEMAIL,
      detail: types.GET_HRMS12X_DETAIL,
      dataNotSend: types.GET_HRMS12X_DETAILNOTSEND,
      sendMailDisp: types.GET_HRMS12X_SENDMAILDISP,
      notSendDisp: types.GET_HRMS12X_NOTSENDDISP
    })
  },
  methods: {
    ...mapMutations({
      setIndexSelected: types.SET_HRMS12X_INDEX_SELECTED,
      setAddEmpemail: types.SET_HRMS12X_ADD_EMPEMAIL
    }),
    ...mapActions({
      receivedHrms12xColumnsLabels: types.RECEIVED_HRMS12X_COLUMNS_LABELS,
      receivedHrms12xIndex: types.RECEIVED_HRMS12X_INDEX,
      postSendmail: types.POST_HRMS12X_SENDMAIL,
      receivedHrms12xListFields: types.RECEIVED_HRMS12X_LISTFIELDS,
      receiveClearDetail: types.RECEIVED_HRMS12X_DETAIL
    }),
    triggerIndexSelect () {
      this.$refs.hrms12xIndex.$emit('$searchBoxTableRef', 'select')
    },
    selectEvent (dataRows) {
      let dataRowsFiltered = dataRows.filter(function (dataRow) {
        return dataRow.flgSelect === 'Y'
      })
      if (dataRowsFiltered.length > 0) {
        this.setAddEmpemail(dataRowsFiltered)
        this.$refs.sendmail.click()
      } else {
        swal({
          title: constLabels('warningTitle'),
          text: constLabels('msgNoRecordSelect')
        })
      }
    },
    triggerSuccess (file, response) {
      this.detail.attach = file.name
    }
  },
  components: {
    popupSendMail
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?7a5b20a8